import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} SchoolSession
 * @property {number} id
 * @property {"active"|"draft"} status
 * @property {string} academic_year
 * @property {string} starts_at - YYYY-MM-DD
 * @property {string} ends_at - YYYY-MM-DD
 * @property {string} created_at
 */

/**
 * @typedef {object} GetSchoolSessionsResponse
 * @property {boolean} success
 * @property {SchoolSession[]} data
 */

export const useGetSchoolSessions = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [sessions, setSessions] = useState([]);
  const { axiosInstance } = useAxios();

  /**
   * Fetch School Sessions
   * @param {object} params
   * @param {(data: SchoolSession[])=>void} [params.onSuccess]
   * @param {(message: string)=>void} [params.onError]
   */
  const getSchoolSessions = async ({ onSuccess, onError } = {}) => {
    try {
      setLoading(true);
      setError("");

      const { data } = await axiosInstance.get(
        `${TENANT_DOMAIN}/school/admin/settings/sessions`,
      );

      const sessionsData = data?.data || [];
      setSessions(sessionsData);

      onSuccess?.(sessionsData);
    } catch (err) {
      let message = ERROR_MESSAGES.INTERNAL_SERVER;

      if (err?.response?.data?.message) {
        message = err.response.data.message;
      }

      setError(message);
      onError?.(message);
    } finally {
      setLoading(false);
    }
  };

  return {
    getSchoolSessions,
    sessions,
    loading,
    error,
  };
};
